import gql from 'graphql-tag';

export const QUERY_LIST_PARTNERS = gql`
  query listPartners(
    $name: String
    $pageSize: PositiveInteger
    $partnerCode: String
    $pageNumber: PositiveInteger
    $country: String
    $referrerId: ID
    $enabled: Boolean
  ) {
    listPartners(
      name: $name
      partnerCode: $partnerCode
      country: $country
      pageSize: $pageSize
      pageNumber: $pageNumber
      enabled: $enabled
      referrerId: $referrerId
    ) {
      edges {
        node {
          id
          name
          partnerCode
          name
          enabled
          country
          market
          type
          paymentPreference
          partnerBanks {
            bankName
            beneficiaryName
            card
            id
            partnerId
          }
          payoutPlanId
          currentTierId
          currentTier {
            name
          }
          commissionPlanId
          commissionPlan {
            id
            name
            externalName
            default
            currency
            tiers {
              name
              bookingCountFrom
              bookingCountTo
              longTermCalculationValue
              shortTermCalculationValue
              calculationRules {
                leaseType
                tenancyLengthFrom
                tenancyLengthTo
                calculationValue
                calculationType
              }
            }
          }
          payoutPlan {
            id
            name
            default
            bookingCompletedPercent
            bookingPaidPercent
            country {
              name
            }
          }
          partnerPromotions {
            id
            referralCommissionPlanId
            partnerId
            referralCommissionPlan {
              id
              name
              externalName
              paymentPreference
              validDateFrom
              validDateTo
              country {
                name
              }
              bookingDestinationCountry {
                name
              }
              bookingDestinationCities {
                name
              }
              currency
              tiers {
                bookingCompletedDateFrom
                bookingCompletedDateTo
                bookingSubmittedDateFrom
                bookingSubmittedDateTo
                longTermCalculationValue
                shortTermCalculationValue
              }
              status
            }
          }

          referrerId
          internalReferrer {
            id
            lastName
            firstName
          }
          createdAt
          updatedAt
          partnerBanks {
            id
            bankName
            beneficiaryName
            card
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;
export const QUERY_LIST_PARTNER_Owners = gql`
  query listPartners(
    $name: String
    $pageSize: PositiveInteger
    $partnerCode: String
    $pageNumber: PositiveInteger
    $country: String
    $referrerId: String
    $enabled: Boolean
  ) {
    listPartners(
      name: $name
      partnerCode: $partnerCode
      country: $country
      pageSize: $pageSize
      pageNumber: $pageNumber
      enabled: $enabled
      referrerId: $referrerId
    ) {
      edges {
        node {
          internalReferrer {
            id
            lastName
            firstName
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      totalCount
    }
  }
`;

export const QUERY_PARTNER_CONTACT = gql`
  query CMS_Partner_Contact($partnerReferrerId: ID, $partnerCode: NonEmptyString) {
    partnerContacts(partnerReferrerId: $partnerReferrerId, partnerCode: $partnerCode) {
      edges {
        node {
          id
          phoneNumber
          emailAddress
          referralLead
          agentMode
          certificationSign {
            certificationStatus
            signStatus
          }
          city {
            id
            name
            state {
              name
            }
            country {
              name
            }
          }
          partner {
            id
            name
            code
            type
            originCountry {
              name
              countryCode
              slug
            }
            payoutPlan {
              name
              default
              bookingCompletedPercent
              bookingPaidPercent
            }
            currentTierId
            currentTier {
              name
            }
            commissionPlan {
              id
              name
              externalName
              default
              currency
              tiers {
                name
                bookingCountFrom
                bookingCountTo
                longTermCalculationValue
                shortTermCalculationValue
                calculationRules {
                  leaseType
                  tenancyLengthFrom
                  tenancyLengthTo
                  calculationValue
                  calculationType
                }
              }
            }
            internalReferrer {
              id
              firstName
              lastName
            }
            withdrawAmountAggregation {
              remainWithdraw
              currency
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_MODIFY_PARTNER_COMMISSION_PLAN = gql`
  mutation MODIFY_PARTNER_COMMISSION_PLAN($commissionPlanId: ID!, $partnerId: ID!) {
    modifyPartnerCommissionPlanId(
      input: { commissionPlanId: $commissionPlanId, partnerId: $partnerId }
    ) {
      result
    }
  }
`;

export const QUERY_LIST_REFERRERS = gql`
  query listReferrers($nameLike: String, $pageSize: Int, $pageNumber: Int) {
    referrers(nameLike: $nameLike, pageSize: $pageSize, pageNumber: $pageNumber) {
      totalCount
      edges {
        node {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const MUTATION_BULK_REASSIGN_REFERRER = gql`
  mutation bulkReassignReferrer($partnerIds: [ID!]!, $referrerId: ID) {
    bulkReassignReferrer(input: { partnerIds: $partnerIds, referrerId: $referrerId }) {
      result
    }
  }
`;

export const MUTATION_UPDATE_INDIVIDUAL_PARTNER_CONTACT = gql`
  mutation updateIndividualPartnerContact(
    $id: ID!
    $cityId: NonEmptyString
    $referralLead: Boolean
    $agentMode: Boolean
  ) {
    updateIndividualPartnerContact(
      data: { cityId: $cityId, referralLead: $referralLead, agentMode: $agentMode }
      id: $id
    ) {
      result
    }
  }
`;

export const QUERY_COUNTRIES = gql`
  query CMS_CountriesView(
    $pageNumber: Int!
    $pageSize: Int!
    $countrySlugs: [String!]
    $billingCycle: [BillingCycle!]
    $sortBy: CountrySortBy
    $sortDirection: SortDirection
    $publishedStatus: NodePublishedFilter
  ) {
    countries(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countrySlugs: $countrySlugs
      billingCycle: $billingCycle
      sortBy: $sortBy
      sortDirection: $sortDirection
      publishedStatus: $publishedStatus
    ) {
      edges {
        node {
          id
          name
          cities {
            edges {
              node {
                id
                name
              }
            }
          }
          states {
            edges {
              node {
                id
                name
                cities {
                  edges {
                    node {
                      id
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

/***** new  */

export const QUERY_PROMOTION_PLAN = gql`
  query CMS_PromotionPlan($id: ID) {
    referralCommissionPlan(id: $id) {
      bookingDestinationCountryId
      bookingDestinationCountry {
        name
        slug
      }
      bookingDestinationCityIds
      bookingDestinationCities {
        name
        id
      }
      type
      status
      validDateFrom
      validDateTo
      default
      externalName
      id
      name
      createdAt
      updatedAt
      countryCode
      countryHasDefault
      currency
      updatedUser {
        firstName
        lastName
      }
      country {
        name
      }
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCountTo
        bookingCountFrom
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
        name
        calculationRules {
          leaseType
          tenancyLengthFrom
          tenancyLengthTo
          calculationValue
          calculationType
        }
      }
    }
  }
`;

export const QUERY_PROMOTION_PLANS = gql`
  query CMS_PromotionPlans(
    $searchName: NonEmptyString
    $countryCode: NonEmptyString
    $pageSize: Int!
    $pageNumber: Int!
    $paymentPreferences: [CommissionPlanPaymentPreference]
    $sortBy: [ReferralCommissionPlanSortBy!]
  ) {
    referralCommissionPlans(
      searchName: $searchName
      pageSize: $pageSize
      pageNumber: $pageNumber
      countryCode: $countryCode
      sortBy: $sortBy
      paymentPreferences: $paymentPreferences
      type: PROMOTIONAL
      status: ACTIVE
    ) {
      totalCount
      pageInfo {
        numPages
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          status
          validDateFrom
          validDateTo
          id
          name
          currency
          country {
            name
          }
          tiers {
            shortTermCalculationValue
            longTermCalculationValue
          }
        }
      }
    }
  }
`;

export const QUERY_COUNTRY = gql`
  query country($pageSize: Int, $pageNumber: Int) {
    countries(pageNumber: $pageNumber, pageSize: $pageSize) {
      edges {
        node {
          name
          countryCode
          currencyCode
        }
      }
    }
  }
`;

export const QUERY_COUNTRY_CITYS = gql`
  query selectedCountryCities($slug: String, $cityPageNumber: Int, $searchCitySlug: [String]) {
    country(slug: $slug) {
      id
      name
      slug
      cities(pageSize: 20, pageNumber: $cityPageNumber, slugs: $searchCitySlug) {
        totalCount
        pageInfo {
          hasNextPage
          hasPreviousPage
          numPages
        }
        edges {
          node {
            id
            name
            slug
          }
        }
      }
    }
  }
`;

export const QUERY_CHECK_DEFAULT_PLAN = gql`
  query defaultPlan($countryCode: NonEmptyString) {
    getCountryDefaultReferralCommissionPlan(countryCode: $countryCode) {
      id
      name
      countryCode
      currency
    }
  }
`;

export const QUERY_CHECK_NAME = gql`
  query checkname($name: NonEmptyString, $type: ReferralCommissionPlanType) {
    checkReferralCommissionPlanNameExists(name: $name, type: $type) {
      exists
    }
  }
`;

export const CREATE_PLAN = gql`
  mutation createPlan($input: CreateReferralCommissionPromotionPlanInput) {
    createReferralCommissionPromotionPlan(input: $input) {
      name
      id
      status
      validDateTo
      validDateFrom
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
      }
    }
  }
`;

export const UPDATE_PLAN = gql`
  mutation updatePlan($input: UpdateReferralCommissionPromotionPlanInput) {
    updateReferralCommissionPromotionPlan(input: $input) {
      name
      id
      status
      validDateTo
      validDateFrom
      tiers {
        shortTermCalculationValue
        longTermCalculationValue
        bookingCompletedDateTo
        bookingCompletedDateFrom
        bookingSubmittedDateFrom
        bookingSubmittedDateTo
      }
    }
  }
`;

export const DELETE_PLAN = gql`
  mutation deletePlan($id: String!) {
    deleteReferralCommissionPlan(id: $id) {
      id
      externalName
      name
    }
  }
`;

export const UPDATE_PARTNER = gql`
  mutation UpdatePartner($input: UpdatePartnerInput!) {
    updatePartner(input: $input) {
      id
      partnerCode
      name
      enabled
      country
      market
      type
      payoutPlanId
      commissionPlanId
      commissionPlan {
        id
      }
      payoutPlan {
        name
      }
      referrerId
      internalReferrer {
        id
        lastName
        firstName
      }
      createdAt
      partnerBanks {
        id
        bankName
        beneficiaryName
        card
      }
    }
  }
`;

export const UPDATE_PARTNER_PROMOTION = gql`
  mutation UpdatePartnerPromotion($input: UpdatePartnerPromotionInput) {
    updatePartnerPromotion(input: $input) {
      id
      partnerId
      referralCommissionPlan {
        id
        name
        bookingDestinationCityIds
      }
      referralCommissionPlanId
    }
  }
`;

export const CREATE_PARTNER_PROMOTION = gql`
  mutation createPartnerPromotion($input: CreatePartnerPromotionInput) {
    createPartnerPromotion(input: $input) {
      id
      partnerId
      referralCommissionPlan {
        id
        name
        bookingDestinationCityIds
      }
      referralCommissionPlanId
      partnerId
      referralCommissionPlan {
        id
        name
        bookingDestinationCityIds
      }
      referralCommissionPlanId
    }
  }
`;

export const DELETE_PARTNER_PROMOTION = gql`
  mutation deletePartnerPromotion($id: ID) {
    deletePartnerPromotion(id: $id) {
      success
    }
  }
`;

export const UPDATE_PARTNER_BANK = gql`
  mutation updatePartnerBank($input: UpdatePartnerBankInput!) {
    updatePartnerBank(input: $input) {
      id
      bankName
      beneficiaryName
      card
      partnerId
    }
  }
`;

export const CREATE_PARTNER_BANK = gql`
  mutation createPartnerBank($input: CreatePartnerBankInput!) {
    createPartnerBank(input: $input) {
      id
      bankName
      beneficiaryName
      card
      partnerId
    }
  }
`;

export const CREATE_PARTNER = gql`
  mutation createPartner($input: CreatePartnerInput!) {
    createPartner(input: $input) {
      id
      partnerCode
      name
      country
      market
      type
      commissionPlan {
        id
      }
      payoutPlan {
        name
      }
      referrerId
      internalReferrer {
        id
        lastName
        firstName
      }
      createdAt
      partnerBanks {
        id
        bankName
        beneficiaryName
        card
      }
    }
  }
`;

export const QUERY_PAYOUT_PLAN_LIST = gql`
  query listPartnerPayoutPlan(
    $pageNumber: PositiveInteger = 1
    $pageSize: PositiveInteger = 10
    $countryCode: NonEmptyString
    $default: Boolean
  ) {
    listPartnerPayoutPlans(
      pageNumber: $pageNumber
      pageSize: $pageSize
      countryCode: $countryCode
      default: $default
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        numPages
      }
      edges {
        node {
          id
          name
          default
          countryId
          affectedLandlordCommission {
            bookingPaid
            bookingCompleted
          }
          bookingCompletedPercent
          bookingPaidPercent
          country {
            id
            name
            currencyCode
          }
          updatedAt
          updatedByCmsUser {
            firstName
            lastName
          }
        }
      }
    }
  }
`;
